var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "position-relative",
      class: {
        "object-container-automation": !_vm.onProperties,
        "object-active":
          _vm.blockActive ||
          (!_vm.onProperties && _vm.id === _vm.propertiesIDBlock),
        "object-disabled": !_vm.onProperties && _vm.isDisableBlock
      },
      staticStyle: { cursor: "default" },
      on: { mouseover: _vm.pauseZoom, mouseleave: _vm.resumeZoom }
    },
    [
      _vm.onProperties
        ? _c(
            "div",
            {
              staticClass: "toggle-disable-block",
              style: [
                _vm.onFullscreen
                  ? { right: "55px", top: "-45px" }
                  : { right: "55px" }
              ]
            },
            [
              _c("j-switch", {
                model: {
                  value: _vm.disable_block,
                  callback: function($$v) {
                    _vm.disable_block = $$v
                  },
                  expression: "disable_block"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "tooltip-toggle-disable" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.disable_block ? "Disable" : "Enable") +
                    " this block\n    "
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.onProperties
        ? [
            _c("img", {
              staticClass: "icon-drag",
              attrs: { src: require("@/assets/new-form-ui/dragged.svg") }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "m__r--5",
              attrs: {
                src: require("@/assets/automation/script.svg"),
                width: "20",
                height: "20"
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "title-automation m__r--5" }, [
              _vm._v("SCRIPT")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "id-block-automation" }, [
              _vm._v(_vm._s(_vm.dataEdit ? "#" + _vm.dataEdit.id : ""))
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.onProperties
        ? _c("img", {
            staticClass: "pull-right cursor-pointer",
            attrs: {
              src: require("@/assets/automation/config.svg"),
              width: "20",
              height: "20"
            },
            on: { click: _vm.showProperties }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.onProperties
        ? _c(
            "div",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "m__t--15",
                  class: { "error-input": _vm.$v.data_js.javascript.$error }
                },
                [
                  _c("label", [_vm._v(" Javascript ")]),
                  _vm._v(" "),
                  _vm.showEditor
                    ? _c("j-monaco-editor", {
                        ref: "scriptEditor",
                        attrs: { value: _vm.data_js.javascript }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "section-border mt-3 mb-4" }, [
                _c("p", { staticClass: "title-section" }, [
                  _vm._v("Configuration")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "desc-section" }, [
                  _vm._v("Additional Action block feature")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "config-toggle" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("j-switch", {
                      model: {
                        value: _vm.data_js.is_async,
                        callback: function($$v) {
                          _vm.$set(_vm.data_js, "is_async", $$v)
                        },
                        expression: "data_js.is_async"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("span", { staticClass: "title-automation" }, [
                _vm._v("Container")
              ]),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  class: { "error-input": _vm.$v.data_js.variable_name.$error }
                },
                [
                  _c("label", [_vm._v(" Variable Name ")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: {
                      "error-required": _vm.$v.data_js.variable_name.$error,
                      "max-length": 255,
                      placeholder: "Variable Name"
                    },
                    model: {
                      value: _vm.$v.data_js.variable_name.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.data_js.variable_name, "$model", $$v)
                      },
                      expression: "$v.data_js.variable_name.$model"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _c("div", [
            _c(
              "div",
              { staticClass: "trigger__label-variable ellipsis m__t--10" },
              [
                _c("img", {
                  staticClass: "m__r--10",
                  attrs: {
                    src: require("@/assets/automation/variable.png"),
                    width: "20",
                    height: "20"
                  }
                }),
                _vm._v(
                  "\n      " + _vm._s(_vm.data_js.variable_name) + "\n      "
                ),
                _c("j-monaco-editor", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  ref: "scriptEditor",
                  attrs: { value: _vm.data_js.javascript }
                })
              ],
              1
            )
          ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-config-toggle-desc" }, [
      _c("p", { staticClass: "title-config-toggle" }, [_vm._v("Asynchronous")]),
      _vm._v(" "),
      _c("p", { staticClass: "desc-config-toggle" }, [
        _vm._v(
          "\n            Processing Block that allows  to execute tasks simultaneously without having to wait for previous tasks to complete first.\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a6e30e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a6e30e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/jVPBlockJavascript.vue
// module id = null
// module chunks = 